import { render } from "./payments-reports.vue?vue&type=template&id=39c1f84c"
import script from "./payments-reports.vue?vue&type=script&lang=js"
export * from "./payments-reports.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__